import { http } from "Utils/http";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { isInObject } from "Utils/utilityFunctions";
import { Col } from "react-bootstrap";
import { CenteredIconTextButton, TextButton, IconTextButton } from "Components/Button";
import { setGlobalErrorStatus } from "Components/StatusHandling";
import { STATUSES, ERROR_MESSAGES } from "../../../../Utils/constants";
import { httpDownload } from "../../../../Utils/httpDownload";
import { WA_GENERATE_URL, WA_VALIDATE_URL } from "../../WebAnalytic/WebAnalyticReportAxiosFuncs";
import { ICONS } from "../../../../Utils/icons";

const ListTableauReportDefinitionsTable = ({ ...props }) => {
    const loginInfo = useSelector(state => state.loginInfo);
    const dispatch = useDispatch();
    //console.log(loginInfo);

    let location = useLocation();
    const navigate = useNavigate();


    const [sortColumn, setSortColumn] = useState({
        sortField: "reportName",
        sortDirection: "asc"
    });

    const [filter, setFilter] = useState(null);

    useEffect(() => {
        var passedData = location.state;

        if (isInObject("filter", passedData)) {
            //console.log("setFilter");
            //console.log(passedData.filter);
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex: 0,
                entryPerPage: 10,
                sortingColumn: sortColumn.sortField,
                sortingOrder: sortColumn.sortDirection,
                searchTerm: ""
            });
        }
        //console.log(filter);
    }, [])


    const getData = async (filter) => {
        var call = filter;
        var url = '/api/manageTableau/getTableauReportDefinitions';

        return http.post(url, call, {
            timeout: 80000,
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }

    const editState = function ({ rowName }) {
        return {
            reportId: rowName.id,
            backRedirect: {
                path: location.pathname,
                state: {
                    ...location.state,
                    tab: "report"
                },

            }
        };
    }

    const getListCols = (selectedList, sortingInfo) => {
        const listColumns = [];

        listColumns.push(Datatable_Column({
            name: "Report Name",
            columnName: "reportName",
            selectedRows: selectedList,
            sortable: true,
            sortingInfo: sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name: "Category Name",
            columnName: 'categoryName',
            selectedRows: selectedList,
            sortable: true,
            sortingInfo: sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name: "CF Setting",
            columnName: "cfSetting",
            selectedRows: selectedList,
            sortable: true,
            sortingInfo: sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name: "CF Version",
            columnName: "cfVersion",
            selectedRows: selectedList,
            sortable: true,
            sortingInfo: sortingInfo,
            formatFunction: (x) => {
                if (x != null) {
                    var n = x.match(/\s[0-9]*.[0-9]*$/);
                    //console.log(n);
                    return n;
                }
                return x;

            }

        }))
        listColumns.push(Datatable_Column({
            name: "For PSO",
            columnName: "forPso",
            selectedRows: selectedList,
            sortable: false,
            sortingInfo: sortingInfo,
            formatFunction: (x) => {
                if (x == 1) {
                    return "Yes";
                }
                else if (x == 0) {
                    return "No";
                }
                else {
                    return null;
                }
            }
        }))
        listColumns.push(Datatable_Column({
            name: "For AHRQ",
            columnName: "forAhrq",
            selectedRows: selectedList,
            sortable: false,
            sortingInfo: sortingInfo,
            formatFunction: (x) => {
                if (x == 1) {
                    return "Yes";
                }
                else if (x == 0) {
                    return "No";
                }
                else {
                    return null;
                }
            }
        }))
        listColumns.push(Datatable_Column({
            name: "For PSOPPC",
            columnName: "forPsoppc",
            selectedRows: selectedList,
            sortable: false,
            sortingInfo: sortingInfo,
            formatFunction: (x) => {
                if (x == 1) {
                    return "Yes";
                }
                else if (x == 0) {
                    return "No";
                }
                else {
                    return null;
                }
            }

        }))
        listColumns.push(Datatable_Column({
            name: "Active",
            columnName: "activeFlag",
            selectedRows: selectedList,
            sortable: true,
            sortingInfo: sortingInfo,
            formatFunction: (x) => {
                if (x == 1) {
                    return "Yes";
                }
                else if (x == 0) {
                    return "No";
                }
                else {
                    return null;
                }
            }
        }))
        listColumns.push(Datatable_Column({
            name: "Edit",
            columnName: "id",
            selectedRows: selectedList,
            sortable: false,
            sortingInfo: sortingInfo,
            isLink: true,
            linkData: {
                pathname: "/manage/tableau/editReportDefinition",
                text: (r) => {
                    return "Edit";
                },
                state: editState
            }
        }))


        return listColumns;
    }

    const tableTitle = function () {
        return "Interactive Report Definitions";
    }

    const tableDescription = function () {
        return null;
    }
    const [selectedCount, setSelectedCount] = useState(0);

    const handleCreateRepDef = () => {
        navigate(
            "/manage/tableau/createReportDefinition",
            {
                state: {
                    backRedirect: {
                        path: location.pathname,
                        state: { ...location.state, tab: "report" }
                    }
                }
            }
        );
    }

    const validateReportAccessLogRequest = async () => {
        let status = STATUSES.SUCCESS;

        return await http
            .post("/api/report/tableau/validate", {}, {
                headers: {
                    Authorization: "Bearer " + loginInfo.token
                }
            })
            .then((res) => {
                return Promise.resolve({ status: status, data: res });
            })
            .catch(function (error) {
                status = STATUSES.ERROR;
                return Promise.reject({ status: status, data: error });
            });
    };

    const generateReportAccessLog = async () => {
        let status = STATUSES.SUCCESS;

        return await httpDownload
            .post("/api/report/tableau/generate", {}, {
                responseType: "blob",
                headers: {
                    Authorization: "Bearer " + loginInfo.token
                }
            })
            .then((res) => {
                return Promise.resolve({ status: status, data: res });
            })
            .catch(function (error) {
                status = STATUSES.ERROR;
                return Promise.reject({ status: status, data: error });
            });
    };

    const handleCreateDocument = async () => {
        const validation = await validateReportAccessLogRequest().catch((error) => {
            const payload = error?.data ?? error;
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: payload?.data?.globalErrorMessageList?.[0] ?? ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });

        if (validation?.data?.status === 1) {
            const res = await generateReportAccessLog(
            ).catch((error) => {
                const payload = error?.data ?? error;
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: payload?.data?.globalErrorMessageList?.[0] ?? ERROR_MESSAGES.DATA_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    },
                    error: error
                });
            });

            if (res?.status?.code === 1) {
                const fileName =
                    res.data.headers["content-disposition"]
                        ?.split("filename=")[1]
                        .split(";")[0]
                        .replace(/^"(.*)"$/, "$1") || "report-access-log.xlsx";

                const url = window.URL.createObjectURL(res.data.data);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
            } else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: ERROR_MESSAGES.DATA_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    },
                    error: res?.data?.status?.text
                });
            }
        }
    }

    return (
        <>

            {
                filter != null
                    ?
                    <DatatableBase
                        tableClassName="listTableauReportDefinitionsTable"
                        uniqueId="listTableauReportDefinitionsTable"
                        filter={filter}
                        setFilter={setFilter}
                        getData={getData}

                        getListCols={getListCols}
                        setSelectedCount={setSelectedCount}
                        hasSelectableRows={false}

                        datatableHeader={tableTitle()}
                        datatableDescription={tableDescription()}
                        searchFieldText={"Search by Report Name, Category Name, CF Setting, and CF Version"}

                        sortingColumn={sortColumn.sortField}
                        sortingOrder={sortColumn.sortDirection}
                    >
                        <Col lg={12} className="d-flex felx-wrap justify-content-end gap-4">
                            {/* <CenteredIconTextButton className="ms-auto flex-grow-1 flex-sm-grow-0" title="Download Interactive Report Access Log" icon={ICONS.download} onClick={handleCreateDocument} variant="normal" content={"Report Access Log"} /> */}
                            <IconTextButton
                                className="reverse"
                                title="Download Interactive Report Access Log"
                                icon={ICONS.download}
                                onClick={handleCreateDocument}
                                variant="normal"
                                content={"Report Access Log"}
                            />
                            <TextButton className="flex-grow-1 flex-sm-grow-0" title="Click on this button to Create a New Document" /*href={"users/createuser"}*/ onClick={handleCreateRepDef} variant="normal" content={"Add New Report"} />
                        </Col>
                    </DatatableBase>
                    : null
            }
        </>
    );
}

export default ListTableauReportDefinitionsTable;